module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_EndCall_16"],"path":[{"$":{"d":"M4,7.5v2a.51.51,0,0,1-.5.5H.77A.79.79,0,0,1,0,9L.27,7.26a2.77,2.77,0,0,1,1.45-2A13,13,0,0,1,8,4a13,13,0,0,1,6.28,1.26,2.77,2.77,0,0,1,1.45,2L16,9a.79.79,0,0,1-.75,1H12.5a.51.51,0,0,1-.5-.5v-2c0-.28-.35-.5-.62-.5A16.3,16.3,0,0,0,8,6.6,16.3,16.3,0,0,0,4.62,7C4.35,7,4,7.22,4,7.5Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_EndCall_16.svg
// module id = vss6
// module chunks = 1